import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import useAPI from "../../../../api/hooks/useAPI";
import useIsIntegrated from "../../../../api/hooks/useIsIntegrated";
import { integrationKeys } from "../../../../api/queryKeys";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";
import LoadingIcon from "../../../../components/LoadingIcon";
import { Toast } from "../../../../components/Toast";
import { logos } from "../../environment/icons/iconExport";
import Guideline from "../components/Guideline";

const PaloAltoTalon = () => {
  const [searchParams] = useSearchParams();

  const [guideMode, setGuideMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [apiKey, setApiKey] = useState("");
  const { isIntegrated, isIntegratedLoading } =
    useIsIntegrated("paloalto_talon");
  const queryClient = useQueryClient();
  const { registerTalonIntegration } = useAPI();
  useEffect(() => {
    if (searchParams.has("viewonly")) {
      setGuideMode(true);
    }
  }, [searchParams]);
  const [showSecret, setShowSecret] = useState(false);

  const handleClickShowSecret = () => setShowSecret(!showSecret);
  const handleMouseDownSecret = () => setShowSecret(!showSecret);
  const onSubmit = async () => {
    setLoading(true);
    try {
      await registerTalonIntegration(apiKey);
      queryClient.invalidateQueries({
        queryKey: integrationKeys.all,
      });
      Toast.success("Talon integration successful");
    } catch (error) {
      if (error.response) {
        Toast.error(`Something went wrong: ${error.response.data.detail}`);
      } else {
        Toast.error("An error occurred while processing the request.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Guideline
        title={
          !isIntegrated && !loading
            ? "Once integrated, Breeze will scan your Palo Alto Talon for security gaps."
            : ""
        }
        image={logos.PrismaAccessBrowserLogo}
        name={"Palo Alto Talon"}
        content={
          loading || isIntegratedLoading ? (
            <LoadingIcon size={25} />
          ) : isIntegrated && !guideMode ? (
            <Box>
              <Typography variant={"h4"}>
                Palo Alto Talon is integrated!
              </Typography>
            </Box>
          ) : (
            <Box>
              <Grid sx={{ width: "700px" }} spacing={1}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    variant="filled"
                    name="apiKey"
                    label="API Key"
                    value={apiKey}
                    type={showSecret ? "text" : "password"}
                    onChange={(e) => setApiKey(e.target.value)}
                    autoComplete="off"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowSecret}
                            onMouseDown={handleMouseDownSecret}
                          >
                            {showSecret ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sx={{ mt: "10px" }}>
                  <PrimaryButton
                    onClick={onSubmit}
                    disabled={loading || !apiKey || guideMode}
                  >
                    Connect
                  </PrimaryButton>
                </Grid>
              </Grid>
            </Box>
          )
        }
      />
    </Box>
  );
};

export default PaloAltoTalon;
